import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import useCardsShowHook from '../useHooks/useCardsShowHook';

function TheComp() {
    const { t } = useLang('costsaving-new');
    useCardsShowHook('.cost-saving-F', '.cost-saving-F');
    return (
        <>

            <section
                className={`${css.section} cost-saving-F GtmModuleData-section`}
                id="cost-saving-F"
                data-section-id={'cost-saving-F'}
                data-section-title={t('F_title')}
            >
                <EcoImg
                    className='img'
                    pc="https://websiteoss.ecoflow.com/upload/image/1768186914591/full-width-carousel%20(1).jpg"
                    pad='https://websiteoss.ecoflow.com/upload/image/1768186913469/Frame%202094654780.jpg'
                    h5="https://websiteoss.ecoflow.com/upload/image/1768186914957/Frame%202094654887.jpg"
                    isOpenLazy
                />
                <div className="F-info">
                    <div className="F-title">{t('F_title')}</div>
                    <div className="F-subtitle">{t('F_subtitle')}</div>
                    <div className="F-desc">{t('F_desc')}</div>
                </div>
            </section>
        </>
    );
}

export default TheComp;
